<template>
  <div>
    <popup
      v-if="dialog"
      @closePopup="closePopup"
      @createData="postSkilles($event)"
      @editData="editSkilles($event)"
      :dialog="dialog"
      :dialogData="dialogData"
      :type="popupType"
    />
    <delete-popup
      @closePopup="deleteDialog = false"
      @deleteData="deleteSkilles($event)"
      :dialog="deleteDialog"
      :item="deleteDialogData"
    />
    <v-row class="mb-n12">
      <v-col>
        <skill-filter
          @getData="setDataFilter($event)"
          @clearData="setDataFilter({})"
        />
      </v-col>
    </v-row>
    <v-row class="mb-4">
      <v-col class="d-flex justify-end"
        ><v-btn color="#007bff" @click="createPopup"
          ><span style="color: white;">{{ $t("add") }}</span></v-btn
        ></v-col
      >
    </v-row>
    <data-table
      @updatePage="getData($event)"
      :headers="tableData.headers"
      :data="tableData.data"
      :editable="edit"
      :deleteable="deleteItem"
      :loader="loader"
      :meta="pagination"
    />
  </div>
</template>
<script>
import dataTable from "@/components/mycomponent/base/dataTable.vue";
import skillFilter from "./filter.vue";
import popup from "@/pages/Dashboard/age-group/craete.vue";
import deletePopup from "@/pages/Dashboard/age-group/delete.vue";
import { Skilles } from "@/store/exercise/skilles";
export default {
  components: {
    dataTable,
    popup,
    deletePopup,
    skillFilter,
  },
  data() {
    return {
      Skilles,
      dialog: false,
      deleteDialog: false,
      dialogData: null,
      deleteDialogData: null,
      popupType: null,
      filterData: {},
    };
  },
  methods: {
    getData(page) {
      Object.assign(this.filterData, { page: page });
      Skilles.getSkilles(this.filterData);
    },
    setDataFilter(data) {
      this.filterData = data;
      this.getData(1);
    },
    createPopup() {
      this.dialog = true;
      this.popupType = "create";
    },
    edit(obj) {
      this.dialog = true;
      this.popupType = "edit";
      this.dialogData = obj;
    },
    deleteItem(obj) {
      this.deleteDialog = true;
      this.deleteDialogData = obj;
    },
    closePopup() {
      this.dialog = false;
    },
    postSkilles(data) {
      Skilles.postSkilles(data);
      this.dialog = false;
    },
    editSkilles(data) {
      Skilles.editSkilles(data.data, data.id);
      this.dialog = false;
    },
    deleteSkilles(id) {
      Skilles.deleteSkilles(id);
      this.deleteDialog = false;
    },
  },
  computed: {
    tableData() {
      return Skilles.tableData;
    },
    loader() {
      return Skilles.getSkillesState.loading;
    },
    pagination() {
      return Skilles.tableData.meta;
    },
  },
  mounted() {
    this.getData(1);
  },
};
</script>
